<template>
  <input
    ref="input"
    v-bind="$attrs"
    v-on="$listeners"
    />
</template>

<script>
export default (function (x) { return x.default || x })(require('./autocompleteImpl.js'))
</script>



// WEBPACK FOOTER //
// node_modules/.pnpm/vue2-google-maps@0.10.7/node_modules/vue2-google-maps/dist/components/autocomplete.vue